export default function getLanguagesNamesByIds(languages, ids) {
    if (!ids || ids.length === 0) return '';

    const names = ids
        .map(id => {
            const lang = languages.find(lang => lang.value === id);
            return lang ? lang.display_name : null;
        })
        .filter(name => name !== null);

    return names.join(', ');
}
